"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTabsStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeTabsStyles = function makeTabsStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;

  var getTabStyles = function getTabStyles() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
    var tabs = tokens.tabs;
    return _objectSpread(_objectSpread({}, tabs[variant].tab.default), {}, {
      fontSize: primitives.fontSizes[3],
      "&:hover": _objectSpread(_objectSpread({}, tabs[variant].tab.hover), {}, {
        fontSize: primitives.fontSizes[3]
      }),
      "&:focus-visible": _objectSpread(_objectSpread({}, tabs[variant].tab.focus), {}, {
        fontSize: primitives.fontSizes[3]
      }),
      "&:active": _objectSpread(_objectSpread({}, tabs[variant].tab.pressed), {}, {
        fontSize: primitives.fontSizes[3]
      }),
      "&.Mui-selected": _objectSpread(_objectSpread({}, tabs[variant].tab.active), {}, {
        fontSize: primitives.fontSizes[3]
      }),
      "&.Mui-disabled": _objectSpread(_objectSpread({}, tabs[variant].tab.disabled), {}, {
        fontSize: primitives.fontSizes[3]
      })
    });
  };

  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          position: "relative",
          "&.DhigTabs--styleVariant--default": _objectSpread(_objectSpread({}, tokens.tabs.default.root), {}, {
            '&[class*="MuiTabs-vertical"] [class*="MuiTabs-scroller"] [class*="MuiTab-root"]': {
              maxWidth: "none",
              alignContent: "flex-start",
              flexWrap: "wrap"
            },
            '& [class*="MuiTab-root"]': getTabStyles()
          }),
          "&.DhigTabs--styleVariant--quiet": _objectSpread(_objectSpread({}, tokens.tabs.quiet.root), {}, {
            '& [class*="MuiTabs-scroller"] [class*="MuiTabs-indicator"]': {
              top: "unset",
              bottom: primitives.spacings["0"],
              "&:after": {
                width: "calc( 100% - ".concat(primitives.spacings["7"], " )"),
                height: "2px",
                content: "''",
                background: tokens.colors["ink-on-background"].rgb
              },
              background: "transparent"
            },
            '&[class*="MuiTabs-vertical"] [class*="MuiTabs-scroller"]': {
              '& [class*="MuiTab-root"]': {
                "&.Mui-selected": {
                  boxShadow: tokens.effects["tab-highlight-left"].boxShadow,
                  "&:focus:active": {
                    boxShadow: tokens.effects["tab-highlight-left"].boxShadow
                  }
                },
                maxWidth: "none",
                alignContent: "flex-start",
                flexWrap: "wrap"
              }
            },
            '& [class*="MuiTab-root"]': getTabStyles("quiet")
          }),
          "& .DhigTabs--scrollButton": {
            color: tokens.colors["ink-on-background"].color,
            height: "100%",
            width: primitives.spacings["8"],
            position: "absolute",
            zIndex: 1,
            background: "linear-gradient(270deg, ".concat(tokens.colors["fade-gradient-transparent"].rgb, " 0%, ").concat(tokens.colors["fade-gradient-semi-transparent"].rgb, " 33.33%, ").concat(tokens.colors["fade-gradient-semi-opaque"].rgb, " 66.67%, ").concat(tokens.colors["fade-gradient-opaque"].rgb, " 100%)"),
            left: primitives.spacings["0"],
            '& [class*="MuiSvgIcon"]': {
              display: "none"
            },
            "&:hover": {
              '& [class*="MuiSvgIcon"]': {
                display: "inline-block"
              }
            },
            // Not addding theming for breakpoints; this is only to override the MUI default.
            "@media (max-width: 599.95px)": _defineProperty({}, "&[class*=\"MuiTabs-scrollButtonsDesktop\"]", {
              display: "flex"
            })
          },
          "& [class*='MuiTabs-scroller'] + .DhigTabs--scrollButton": {
            background: "linear-gradient(270deg, ".concat(tokens.colors["fade-gradient-opaque"].rgb, " 0%, ").concat(tokens.colors["fade-gradient-semi-opaque"].rgb, " 33.33%, ").concat(tokens.colors["fade-gradient-semi-transparent"].rgb, " 66.67%, ").concat(tokens.colors["fade-gradient-transparent"].rgb, " 100%)"),
            right: primitives.spacings["0"],
            left: "unset"
          }
        },
        indicator: {
          left: primitives.spacings["0"],
          top: primitives.spacings["0"],
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    },
    MuiTab: {
      defaultProps: {
        wrapped: true,
        tabIndex: 0
      },
      styleOverrides: {
        root: {
          "&": getTabStyles(),
          border: "".concat(primitives.borderWidths.large, " solid transparent"),
          minWidth: "unset"
        },
        textColorInherit: {
          opacity: primitives.opacity["opaque"]
        }
      }
    }
  };
};

exports.makeTabsStyles = makeTabsStyles;